export const visit = (vm, at) => {
vm(require("ui-addon-draggable/lang/en.lyaml"));
at({ "uiAddonDraggableCompat": { "placeholder": "Placeholder" } });
};